/**
 * Plotësimi i një shablloni HTML me vlerat e kontratës.
 *
 * Vlerat vijnë nga GET /api/worker-contracts/:id/fields (backend/services/
 * contractFields.js) — të formatuara si në një kontratë të nënshkruar: data
 * 05.01.2026, paga 1.200,00 €, departamenti me emër. Më parë secila faqe kishte
 * listën e vet të fushave dhe lexonte `data[tag]` drejt: @PersonalId dhe
 * @Birthday dilnin "--", @Department si numër.
 */
import { authFetch } from '../services/apiServices';

export async function fetchContractFields(contractId) {
  if (!contractId) return null;
  try {
    const res = await authFetch(`/api/worker-contracts/${contractId}/fields`);
    const json = await res.json().catch(() => ({}));
    return res.ok && json.success ? json.data : null;
  } catch {
    return null;
  }
}

/**
 * @param {string} html     shablloni me @Fusha
 * @param {object} fields   'FirstName' → 'Arta'
 * @param {string} empty    çfarë del kur fusha s'ka vlerë
 */
export function fillHtmlTemplate(html, fields = {}, { empty = '—' } = {}) {
  let out = String(html || '');
  // Më të gjatat së pari: @HourSalaryWeekend para @HourSalary.
  Object.keys(fields).sort((a, b) => b.length - a.length).forEach((key) => {
    const value = fields[key];
    const re = new RegExp(`@${key}(?![A-Za-z0-9_])`, 'g');
    if (key === 'Image') {
      out = out.replace(re, value ? `<img src="${value}" alt="" style="max-width:120px" />` : empty);
    } else if (key === 'CompanyLogo') {
      out = out.replace(re, value ? `<img src="${value}" alt="logo" style="max-height:64px" />` : '');
    } else {
      out = out.replace(re, value === undefined || value === null || value === '' ? empty : String(value));
    }
  });
  return out.replace(/<!-- pagebreak -->/g, '<br style="page-break-before: always">');
}
